export const otpDeliveryMechanisms = {
  SMS: 'SMS'
};